import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const PaymentListViewChunk = React.lazy(() =>
  import('../containers/PaymentListView').then(({ PaymentListView }) => ({
    default: PaymentListView,
  }))
)

export const PaymentListPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.paymentListPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.paymentListPageTitle),
        },
      ]}
    >
      <PaymentListViewChunk />
    </Page>
  )
}
